"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require("react-intl");

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ItemSelector = require("./ItemSelector");

var _ItemSelector2 = _interopRequireDefault(_ItemSelector);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var VariationSelector = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(VariationSelector, _React$PureComponent);

  function VariationSelector() {
    _classCallCheck(this, VariationSelector);

    return _possibleConstructorReturn(this, _getPrototypeOf(VariationSelector).apply(this, arguments));
  }

  _createClass(VariationSelector, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          variation = _this$props.variation,
          selectedItem = _this$props.selectedItem,
          askToSelectVariation = _this$props.askToSelectVariation,
          designTokens = _this$props.designTokens;
      return _react2["default"].createElement("div", {
        className: designTokens && designTokens.skuSelectorContainer || 'vtex-sku-selector__container flex flex-column mb7'
      }, _react2["default"].createElement("div", {
        className: "vtex-sku-selector__name-container ma1"
      }, _react2["default"].createElement("span", {
        className: "vtex-sku-selector__name db t-small overflow-hidden mb3"
      }, _react2["default"].createElement("span", {
        className: "c-muted-2"
      }, variation.name), askToSelectVariation ? _react2["default"].createElement("span", {
        className: "c-danger ml3 t-mini"
      }, _react2["default"].createElement(_reactIntl.FormattedMessage, {
        id: "sku-selector.select-warning"
      }), ' ', variation.name) : null), _react2["default"].createElement("div", {
        className: "inline-flex flex-wrap ml2"
      }, variation.items.map(function (item, i) {
        return _react2["default"].createElement(_ItemSelector2["default"], {
          selected: selectedItem === item.label,
          key: i,
          handleSelect: item.onSelectItem,
          label: item.label,
          thumbSrc: item.thumbSrc,
          isAvailable: item.available,
          variation: variation.name
        });
      }))));
    }
  }]);

  return VariationSelector;
}(_react2["default"].PureComponent);

VariationSelector.propTypes = {
  variation: _propTypes2["default"].shape({
    name: _propTypes2["default"].string.isRequired,
    items: _propTypes2["default"].arrayOf(_propTypes2["default"].shape({
      label: _propTypes2["default"].string.isRequired,
      available: _propTypes2["default"].bool.isRequired,
      thumbSrc: _propTypes2["default"].string,
      onSelectItem: _propTypes2["default"].func.isRequired
    })).isRequired
  }).isRequired,

  /** It's either null when no item is selected or the selected item index */
  selectedItem: _propTypes2["default"].string,
  askToSelectVariation: _propTypes2["default"].bool,
  designTokens: _propTypes2["default"].shape({
    skuSelectorContainer: _propTypes2["default"].string
  })
};
exports["default"] = VariationSelector;